export default {
  data() {
    return {
      error: null,
      loadingsCount: 0
    };
  },
  methods: {
    showLoading: function () {
      this.loadingsCount++;
      this.$loadingService.startLoading();
    },

    hideLoading: function () {
      this.loadingsCount--;
      if (!this.loadingsCount) this.$loadingService.endLoading();
    },

    showErrorModal(error) {
      this.$errorService.showError(error);
    },

    handleHttpError(error, showModal, errorText) {
      if (errorText) {
        this.setError(showModal, errorText);
        return;
      }

      if (error && error.response && error.response.status == 400) {
        this.setError(showModal, error.response.data.Message);
        return;
      }

      this.setError(showModal, 'An unexpected error has occured');
    },

    setError(showModal, errorText) {
      if (showModal) this.showErrorModal(errorText);
      else this.error = errorText;
    }
  }
};
